// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.psjzyqeFmXcgfAktGhOI{flex-direction:column;gap:24px;display:flex}.q5m0JkrzncI5DBhn3WqH{flex-direction:column;gap:4px;display:flex}.aNyIfYngdIwmnMd5Kf2O{justify-content:flex-end;gap:8px;padding-top:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `psjzyqeFmXcgfAktGhOI`,
	"notification": `q5m0JkrzncI5DBhn3WqH`,
	"actions": `aNyIfYngdIwmnMd5Kf2O`
};
export default ___CSS_LOADER_EXPORT___;
